import { DeepLinkProps } from '@thesisedu/feature-react'
import { UserGroupPrefixDeepLinkRemapper } from '@thesisedu/feature-users-web'
import React from 'react'

export function ThreadDeepLinkRemapper(props: DeepLinkProps) {
  return (
    <UserGroupPrefixDeepLinkRemapper {...props} url={props.url.replace('dm-thread', 'messages')} />
  )
}
